import request from './request'
import requestApi from './httpApi'

// 图片验证
export function captcha() {
    return requestApi({
        url: "/h5/mobile/api/getCaptcha",
        method: "POST",
        data: {
            "captchaType": "slide"
        }
    })
};

// 注销
export function cancellation(data) {
    return requestApi({
        url: "/h5/mobile/usercoin/cancelEmail",
        method: "POST",
        data
    })
};

// 登录
export function loginApi(data) {
    return request({
        url: "/usercoin/tellogin",
        method: "POST",
        data
    })
};

// 验证码登录
export function telloginsmsApi(data) {
    return request({
        url: "/usercoin/telloginsms",
        method: "POST",
        data
    })
};

// 退出登录
export function logoutApi(data) {
    return request({
        url: "/usercoin/logout",
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data
    })
};

// 注册
export function pcregApi(data) {
    return request({
        url: "/usercoin/pcreg",
        method: "POST",
        data
    })
};

// 图片验证
export function captchaApi(data) {
    return request({
        url: "/captcha/get",
        method: "POST",
        data
    })
};

// 验证码
export function sendsmsApi(data) {
    return request({
        url: "/usercoin/sendsms",
        method: "POST",
        data
    })
};

// 用户信息
export function usercoinApi(data) {
    return request({
        url: "/usercoin/loginbase",
        method: "POST",
        data
    })
};

// 首页头部视频
export function homeVideoApi(data) {
    return request({
        url: "/index/index",
        method: "POST",
        data
    })
};

// 首页为你推荐
export function homeRecommApi(data) {
    return request({
        url: "/index/index",
        method: "POST",
        data
    })
};

// 首页最新资讯
export function homeMessageApi(data) {
    return request({
        url: "/index/index",
        method: "POST",
        data
    })
};

// 首页互动日常
export function homeDailyApi() {
    return request({
        url: "/index/interaction",
        method: "GET",
    })
};

// 首页二维码信息
export function configDataApi() {
    return request({
        url: "/config/index",
        method: "GET",
    })
};

// 互动空间推荐列表
export function recommendListApi(data) {
    return request({
        url: "/index/recommendlist",
        method: "POST",
        data
    })
};

// 互动空间视频播放
export function interactionApi(id) {
    return request({
        url: `/index/interaction_one?id=${id}`,
        method: "GET",
    })
};

// 帮助中心
export function helpListApi(data) {
    return request({
        url: "/index/index",
        method: "POST",
        data
    })
};

// 帮助中心详情
export function helpDetailApi(id) {
    return request({
        url: `/header/get?id=${id}`,
        method: "GET",
    })
};

// 游玩日常
export function playacticleApi() {
    return request({
        url: `/playacticle/index`,
        method: "GET",
    })
};

// 游玩日常分页
export function playlistApi(data) {
    return request({
        url: `/playacticle/playlist`,
        method: "POST",
        data
    })
};

// 充值列表
export function tpaysetlistApi(data) {
    return request({
        url: `/tpayset/getlist`,
        method: "POST",
        data
    })
};

// 支付宝充值
export function alipcpayApi(data) {
    return request({
        url: `/pay/alipcpay?token=${data.token}&payId=${data.payId}`,
        method: "GET",
    })
};




